module.exports = __webpack_public_path__ + "static/media/quakerstate.b2bed8f8.png";